import { SearchGroup, Status } from "@core/data"
import { AdvancedReport, AnyReportTemplate } from "@core/data/types/advanced-report"
import { StateToken } from "@ngxs/store";

// Main State
export interface AdvancedReportModel {
    key: string,
    ownerOrgKey: string,

    pageKeys: string[],

    report: AdvancedReport,
    templateOptions: SearchGroup<AnyReportTemplate>[];

    status: Status,
    rightDrawerStatus: Status,
}

export interface AdvancedReportStateModel {
    reportKey: string,
    shareKey: string,
    ownerOrgKey: string,
    sampleKeys: string[],
    editMode: boolean,
    entities: {
        [key: string]: AdvancedReportModel,
    }
}

export const REPORT_STATE_TOKEN = new StateToken<AdvancedReportStateModel>('advanced_report_state');